import { DEFAULT_DRUID_FILTERS_LIST } from './defaultDruidDimensions';

export const QUICK_LINKS_DIMENSIONS_WHITE_LIST = [...DEFAULT_DRUID_FILTERS_LIST] as const;
